<template>
	<div>
		<div class="billetin-board">
			<div class="title color-black-gray1">公布欄</div>
			<div class="items">
				<div class="item layout-row pointer" v-for="(item, i) in list" :key="i" @click="openNews(i)">
					<div class="thumb" :style="`background-image:url(${item.imgUrl})`" />
					<div class="content layout-column">
						<div class="item-title">{{item.title}}</div>
						<div class="item-date">{{item.date | transformDate}}</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="800px">
			<div class="news-modal layout-column layout-hv-center">
				<div class="thumb" :style="`background-image:url(${selectedNews.imgUrl})`" />
				<div class="content layout-column">
					<div class="date color-black-gray1">{{selectedNews.date | transformDate}}</div>
					<div class="title color-black-gray1">{{selectedNews.title}}</div>
					<div class="line"></div>
					<div class="col color-black">
						<span v-for="(text, i) in selectedNews.content.split('\n')" :key="i" class="text">{{text}}</span>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import momentTZ from "moment-timezone";
import { mapActions, mapState } from 'vuex';

export default {
	data() {
		return {
			dialogVisible: false,
			selectedIndex: 0
		};
	},
	computed: {
		...mapState('billboard', ['list']),
		selectedNews() {
			return this.list[this.selectedIndex] || {
				title: "標題",
				date: momentTZ(Date.now()).tz("Asia/Taipei").format("YYYY-MM-DD"),
				imgUrl: require("@/assets/news-default.jpg"),
				content: "無"
			};
		},
	},
	filters: {
		transformDate(val) {
			return momentTZ(val)
				.tz("Asia/Taipei")
				.format("YYYY-MM-DD");
		}
	},
	methods: {
		...mapActions('billboard', ['getAllPosts']),
		openNews(index) {
			this.selectedIndex = index;
			this.dialogVisible = true;
		}
	},
	async created() {
		await this.getAllPosts();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.billetin-board {
	padding: 17px;
	background-color: #f7fbfe;

	.title {
		font-size: 1.5em;
		margin-bottom: 20px;
	}

	.items {
		padding-left: 7px;
		overflow: auto;

		.item {
			font-size: 14px;
			margin-bottom: 18px;
			font-weight: 500;
			padding-right: 3px;

			.thumb {
				width: 90px;
				height: 60px;
				flex-shrink: 0;
				margin-right: 13px;
				background-position: center;
				background-size: cover;
				background-repeat: no-repeat;
			}
		}
	}

	.items::-webkit-scrollbar {
		width: 3px;
	}

	/* Handle */
	.items::-webkit-scrollbar-thumb {
		-webkit-border-radius: 10px;
		border-radius: 20px;
		background-color: #60adf5;
	}
}

.news-modal {
	.thumb {
		width: 534px;
		height: 300px;
		margin-bottom: 20px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.content {
		align-items: flex-start;
		width: 100%;
		padding: 0 30px 15px 30px;
		font-size: 14px;
		font-weight: 500;

		.date {
			margin-bottom: 7px;
		}

		.title {
			font-size: 16px;
			margin-bottom: 13px;
		}

		.line {
			width: 100%;
			height: 2px;
			border: solid 1px #c0c4cc;
			margin-bottom: 13px;
		}

		.text {
			line-height: 1.7;
		}
	}
}
</style>